import { render, staticRenderFns } from "./pkList.vue?vue&type=template&id=192ac440&scoped=true&"
import script from "./pkList.vue?vue&type=script&lang=js&"
export * from "./pkList.vue?vue&type=script&lang=js&"
import style0 from "./pkList.vue?vue&type=style&index=0&id=192ac440&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "192ac440",
  null
  
)

export default component.exports